import React, { useEffect, useState } from 'react';

import UserAvatarButtonView from './UserAvatarButtonView';

import { useMytaverse } from '@providers/MytaverseProvider';
import { useOverlayContext } from '@providers/OverlayProvider';
import OVERLAYS from '@constants/overlays';

const UserAvatarButton = () => {
  const [showUserSettingModal, setShowUserSettingModal] = useState(false);
  const { user } = useMytaverse();
  const {
    addToCurrentlyOpenOverlays,
    removeFromCurrentlyOpenOverlays,
    hideCurrentlyOpenOverlays,
    isOverlayCurrentlyOpen,
  } = useOverlayContext();

  useEffect(() => {
    return () => {
      removeFromCurrentlyOpenOverlays(OVERLAYS.PROFILE);
    };
  }, [removeFromCurrentlyOpenOverlays]);

  const toggleModal = () => {
    if (showUserSettingModal) {
      removeFromCurrentlyOpenOverlays(OVERLAYS.PROFILE);
    } else {
      addToCurrentlyOpenOverlays(OVERLAYS.PROFILE);
    }
    setShowUserSettingModal((prevState) => !prevState);
  };

  useEffect(() => {
    if (hideCurrentlyOpenOverlays) {
      setShowUserSettingModal(false);
    } else {
      if (isOverlayCurrentlyOpen(OVERLAYS.PROFILE)) {
        setShowUserSettingModal(true);
      }
    }
  }, [hideCurrentlyOpenOverlays, isOverlayCurrentlyOpen]);

  if (!user) {
    return null;
  }

  return (
    <UserAvatarButtonView
      profileImage={user.profileImage.url}
      name={user.name || user.email}
      showUserSettingModal={showUserSettingModal}
      toggleModal={toggleModal}
    />
  );
};

export default UserAvatarButton;
